import { render } from 'react-dom';
import { App } from './components/App';

import '@atlaskit/css-reset/dist/bundle.css';

/* Workaround for https://product-fabric.atlassian.net/browse/DSP-3980 */
import './atlaskit-tokens.css';

render(<App />, document.getElementById('root'));
